var mobileFlag=false;
var userAgentInfo = navigator.userAgent;
var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
        mobileFlag = true;
        break;
    }
}


export default {
    isMobile:mobileFlag,
    isAndroid:function(){
        var userAgentInfo = navigator.userAgent;
        console.log(userAgentInfo)
        return userAgentInfo.indexOf("Android") > 0 /*&& (window.location.href.indexOf('/www/index.html')!=-1 || window.location.href.indexOf('/h5/index.html')!=-1)*/;
    },
    isIPhoneX:function(){
        return /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
    },
    isIPhoneXSMax:function(){
        return /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
    },
    isIPhoneXR:function(){
        return /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
    }
}